import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import DibujosCreate from "./DibujosCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoDibujos() {
  const { user } = useContext(AuthContext);
  const URL_DIBUJOS = process.env.REACT_APP_URL_DIBUJOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [dibujos, setDibujos] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_DIBUJOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDibujos = response.data;
        setDibujos(allDibujos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editDibujo(event) {
    event.preventDefault();
    const URL_DIBUJOS_EDIT = `${process.env.REACT_APP_URL_DIBUJOS}/${idEdit}`;
    axios
      .patch(
        URL_DIBUJOS_EDIT,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Dibujo',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name) {
        setName(name);
        setIdEdit(idEdit);
        toggle();
  }

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  return (
    <>
      <Header />
      <br />
      <div className="container">
        { user.menu_articulos ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-tshirt" style={{ marginRight: 8, color: "#8b5cf6" }} />
                  Dibujos
                </h3>
                <p className="page-subtitle">Catálogo de dibujos</p>
              </div>
              <div className="page-actions">
                <Button size="sm" color="success" onClick={toggleCreate}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Dibujo
                </Button>
              </div>
            </div>
            <Table
              size="sm"
              striped
              borderless
              className="table-responsive-xl table-dark-header"
            >
              <thead>
                <tr>
                  <th className="tituloTabla">Nombre</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {dibujos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                      return (
                        <tr>
                          <td>{a.name}</td>
                          <td>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaInfo(a._id, a.name)}
                            >
                              <i class="far fa-edit"></i>{" "}
                            </Button>
                          </td>
                        </tr>
                      );
                  })}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      {/* Modal de alta */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Nuevo Dibujo
        </ModalHeader>
        <ModalBody>
          <DibujosCreate />
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-edit" style={{ marginRight: 8 }} />
          Editar Dibujos
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-tag" />
              <span className="form-section-title">Datos</span>
            </div>
            <div className="form-section-body">
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editDibujo}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoDibujos;
